import { ShepherdOptionsWithType, Tour } from 'react-shepherd';
import { addWalletTourEs, addWalletTourEn } from '@/assets';

const tourOptions: Tour.TourOptions = {
  defaultStepOptions: {
    classes: '',
    scrollTo: { behavior: 'smooth', block: 'center' },
    modalOverlayOpeningPadding: 4,
    canClickTarget: false,
  },
  useModalOverlay: true,
};

const steps = (
  t: (key: string) => string,
  isMobileDevice: boolean,
  lang: 'es' | 'en'
) =>
  [
    {
      id: 'add-wallet',
      title: t('tutorialTitle'),
      text: !isMobileDevice
        ? t('tutorialDescription')
        : `
        <p>${t('tutorialDescription')}</p>
        <img src='${lang === 'es' ? addWalletTourEs : addWalletTourEn}' />
      `,
      attachTo: {
        element: isMobileDevice ? '' : '#add-wallet-button',
        on: 'top',
      },
      buttons: [
        {
          text: t('tutorialButton'),
          type: 'cancel',
        },
      ],
    },
  ] as ShepherdOptionsWithType[];

export { tourOptions, steps };
